const SituacaoEnum = {
    ABERTO: 'ABERTO',
    APROVACAO: 'APROVAÇÃO',
    APROVADO: 'APROVADO',
    REPROVADO: 'REPROVADO',
    AGUARDANDO_AJUSTE: 'AGUARDANDO AJUSTE'
};

export default SituacaoEnum;
